

export function hsl(hue, sat, light) {
  return `hsl(${(hue % 360 + 360) % 360} ${sat}% ${light}%)`
}
